/**
 * Where to send the user back to after login / customer selection.
 *
 * Keeps the query string and hash, not just the path: an OAuth return such as
 * ``/billing/connections?pending=…`` is useless without its query.
 */
export function returnTo(location: { pathname: string; search?: string; hash?: string }): string {
  return `${location.pathname}${location.search ?? ''}${location.hash ?? ''}`;
}
